import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import translations from "../../../constants/purchaseInvoices/translations/supplierInvoiceTranslations";
function ConfirmationDialog({ selectedFileName, openDelete, onClose, onDelete, isPending }) {
    return (
        <Dialog open={openDelete} dir="rtl">
            <DialogTitle>{translations.confirmDeletion}</DialogTitle>
            <DialogContent> 
                {translations.deleteConfirmation}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {translations.cancel}
                </Button>
                <Button 
                    onClick={() => onDelete(selectedFileName)}  
                    color="error" 
                    variant="contained" 
                    disabled={isPending}
                >
                    {isPending ? 'מוחק...' : translations.delete}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
export default ConfirmationDialog;
